import {createFileRoute} from '@tanstack/react-router'
import {type} from 'arktype'

import stripDefaultSearchParams from '@/utils/router/middlewares/stripDefaultSearchParams'
import {fallbackToDefault} from '@/utils/schema/fallback'
import searchParamString from '@/utils/schema/searchParamString'

const DEFAULT_VALUES = {
  custom: false,
  applyRewards: false,
  method: false,
  coupon: '',
}

const paymentSearchSchema = type({
  custom: fallbackToDefault(type.boolean, DEFAULT_VALUES.custom),
  applyRewards: fallbackToDefault(type.boolean, DEFAULT_VALUES.applyRewards),
  coupon: fallbackToDefault(searchParamString, DEFAULT_VALUES.coupon),
  method: fallbackToDefault(type.boolean, DEFAULT_VALUES.method),
})

export const Route = createFileRoute('/_shop/payment/')({
  validateSearch: paymentSearchSchema,
  search: {
    middlewares: [stripDefaultSearchParams(DEFAULT_VALUES)],
  },
})
